"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopArea = void 0;
var _auth = require("@ori/auth");
var _featureToggles = require("@ori/feature-toggles");
var _login = require("@ori/login");
var _personalMenu = require("@ori/personal-menu");
var _topArea = require("@ori/top-area");
var _router = require("next/router");
var _react = require("react");
var _logger = require("../../logger");
var _TopAreaFeature = require("./TopAreaFeature");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const logger = _logger.mainLogger.createChild('TopArea');
const LazyNotificationMenu = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require('@ori/notification-menu')))).NotificationsMenu
}));
const LazyPersonalMenu = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require('@ori/personal-menu')))).PersonalMenu
}));
const TopArea = ({
  showSearchOnScroll,
  topAreaNavigation
}) => {
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  const router = (0, _router.useRouter)();
  const onQueryParamRemove = (0, _react.useCallback)(name => {
    if (router.query[name] == null || !router.isReady) {
      return;
    }
    // Get the current URL parts
    const {
      hash,
      pathname,
      searchParams
    } = new URL(router.asPath, window.location.origin);
    searchParams.delete(name);
    // We cannot use router.query, because that would use internal query parameters too (lang, tenant, etc)
    const query = Object.fromEntries(searchParams.entries());
    router.replace(router, {
      pathname,
      query,
      hash
    }, {
      shallow: true
    }).catch(error => logger.error(new Error('Failed to remove query param', {
      cause: error
    })));
  }, [router]);
  const onQueryParamSet = (0, _react.useCallback)((name, value) => {
    if (router.query[name] === value || !router.isReady) {
      return;
    }
    router.query[name] = value;

    // Get the current URL parts
    const {
      hash,
      pathname,
      searchParams
    } = new URL(router.asPath, window.location.origin);
    // Update the query parameter
    if (value === undefined) {
      searchParams.delete(name);
    } else {
      searchParams.set(name, value);
    }

    // We cannot use router.query, because that would use internal query parameters too (lang, tenant, etc)
    const query = Object.fromEntries(searchParams.entries());
    router.replace(router, {
      pathname,
      query,
      hash
    }, {
      shallow: true
    }).catch(error => logger.error(new Error('Failed to set query param', {
      cause: error
    })));
  }, [router]);
  const isNotificationsEnabled = isFeatureEnabled(_TopAreaFeature.TopAreaFeature.DisplayNotificationIcon);
  const topAreaConfiguration = (0, _react.useMemo)(() => ({
    personalMenuInitialData: undefined,
    showSearchOnScroll,
    ssoLoginUrl: _login.SSO_IDENTITY_LOGIN_PATH,
    topAreaNavigation
  }), [showSearchOnScroll, topAreaNavigation]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_topArea.TopArea, {
      configuration: topAreaConfiguration,
      removeQueryParameter: onQueryParamRemove,
      setQueryParameter: onQueryParamSet,
      mobilePersonalMenuOutlet: isAnonymousUser ? undefined : /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_personalMenu.SkeletonLoader, {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(LazyPersonalMenu, {})
      })
    }), isNotificationsEnabled && !isAnonymousUser ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: null,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(LazyNotificationMenu, {})
    }) : null]
  });
};
exports.TopArea = TopArea;
